import {createStore} from 'zustand';

interface ChartsFilterStore {
  period: string;
  customPeriodStart: string;
  customPeriodEnd: string;
  setPeriod: (period: string) => void;
  setCustomPeriod: (start: string, end: string) => void;
  resetCustomPeriod: () => void;
}

export const createPrimaryChartsFiltersStore = () =>
  createStore<ChartsFilterStore>((set) => ({
    period: 'YEAR',
    customPeriodStart: '',
    customPeriodEnd: '',

    setPeriod: (period) => set({period}),
    setCustomPeriod: (start, end) => set({customPeriodStart: start, customPeriodEnd: end}),
    resetCustomPeriod: () => set({customPeriodStart: '', customPeriodEnd: ''}),
  }));
